import {useEffect, useRef} from 'react';

import sdk from '@/sdk';
import eventBus, {ADD_MATERIAL} from '@/eventBus';
import toast, {ToastType} from '@/components/Toast';
import {reportClickAddMaterial} from '@/buried/material';

/**
 * 模板库配置逻辑
 * @param docForbidCopy 文档是否设置，只读成员禁止复制
 * @param enable 是否开启模板库
 * @returns
 */
export const useMaterialConfig = ({
    docGuid,
    docForbidCopy,
    enable,
}: {
    docGuid: string;
    docForbidCopy: boolean;
    enable: boolean;
}) => {
    const docForbidCopyRef = useRef<boolean>(false);

    useEffect(() => {
        docForbidCopyRef.current = docForbidCopy;
    }, [docForbidCopy]);

    return {
        enable,
        canAddMaterial: () => {
            if (docForbidCopyRef.current) {
                toast({
                    type: ToastType.Warning,
                    content: '该文档已设置只读成员禁止复制，无法保存卡片为模板。',
                });

                return false;
            }
            return true;
        },
        addMaterial: async (
            nodes: any[],
            options: {
                type?: string;
                nodeInfoList: Array<{type: string, path: number[]}>;
            }
        ): Promise<void> => {
            reportClickAddMaterial({docId: docGuid});

            try {
                const ksServer = await sdk.getKsServer();
                const res = await ksServer.addMaterial({
                    docGuid,
                    nodeMessageList: options.nodeInfoList,
                    content: nodes,
                });

                if (res) {
                    eventBus.emit(ADD_MATERIAL, res);
                } else {
                    toast({
                        type: ToastType.Error,
                        content: '保存失败，请稍后重试',
                    });
                }
            } catch (error) {
                console.error(error);

                toast({
                    type: ToastType.Error,
                    content: '保存失败，请稍后重试',
                });
            }
        },
    };
};
